import { getAccessURLStaticStore } from 'lincd-s3/utils/accessUrl';
import { SentryFrontendErrorLogger } from 'lincd-sentry/utils/SentryFrontendErrorLogger';
import { BackendAPIStore } from 'lincd-server/shapes/quadstores/BackendAPIStore';
import { getAccessUrlLocalFileStore } from 'lincd-server/utils/accessUrl';
import { LinkedErrorLogging } from 'lincd/utils/LinkedErrorLogging';
import { LinkedFileStorage } from 'lincd/utils/LinkedFileStorage';
import { LinkedStorage } from 'lincd/utils/LinkedStorage';

//send all data requests to a backend API, the backend storage-config.js will then determine how those requests are handled
const store = new BackendAPIStore();
LinkedStorage.setDefaultStore(store);

// set default access URL for LinkedFileStorage
if (process.env.NODE_ENV === 'development') {
  LinkedFileStorage.setDefaultAccessURL(getAccessUrlLocalFileStore());
} else {
  LinkedFileStorage.setDefaultAccessURL(getAccessURLStaticStore());
}

// init sentry logging before rendering the app
LinkedErrorLogging.setDefaultLogger(new SentryFrontendErrorLogger());
